import React, { useRef, useState } from 'react';
import { Menu, X } from 'lucide-react';
import WhatsAppCTA from './WhatsAppCTA';
import { CTA_LABEL, quoteMessage } from '../data/site';
import { ScrollTrigger, useGSAP } from '../lib/gsap';

const navLinks = [
  { label: 'Eventos', href: '#eventos' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Pacotes', href: '#pacotes' },
  { label: 'Dúvidas', href: '#duvidas' },
];

export const Logo = () => (
  <span className="flex flex-col leading-none">
    <span className="font-display text-xl font-bold tracking-tight">Atitude</span>
    <span className="text-[11px] font-medium text-soft">Som e Luz</span>
  </span>
);

const Header = () => {
  const ref = useRef(null);
  const [solid, setSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Fundo sólido só depois de sair do topo (ScrollTrigger dispara uma vez por troca).
  useGSAP(() => {
    ScrollTrigger.create({ start: 'top -24', onToggle: (self) => setSolid(self.isActive) });
  });

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      ref={ref}
      data-testid="header"
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
        solid || menuOpen ? 'border-b border-line bg-page/90 backdrop-blur-lg' : 'border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-8">
        <a href="#topo" onClick={(e) => handleNavClick(e, '#topo')} data-testid="header-logo" aria-label="Atitude Som e Luz, início">
          <Logo />
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={(e) => handleNavClick(e, link.href)} className="text-sm text-soft transition-colors hover:text-ink">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <WhatsAppCTA message={quoteMessage()} source="header" size="sm" testid="header-cta-button">
            {CTA_LABEL}
          </WhatsAppCTA>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="-mr-2 p-2 md:hidden"
          data-testid="mobile-menu-toggle"
          aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {menuOpen && (
        <nav className="px-4 pb-4 md:hidden" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} onClick={(e) => handleNavClick(e, link.href)} className="block py-3 text-lg font-medium">
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
